import type { ProjectSummarySheet } from "../../api/projectSummarySheet";

/** The author or any procurement officer may edit / resubmit a DRAFT or REJECTED sheet. */
export function canEditProjectSummarySheet(
  sheet: Pick<ProjectSummarySheet, "status" | "submittedById"> | undefined,
  user: { id?: string; role?: string } | null | undefined
): boolean {
  if (!sheet || !user) return false;
  if (sheet.status !== "DRAFT" && sheet.status !== "REJECTED") return false;
  return sheet.submittedById === user.id || user.role === "PROCUREMENT_OFFICER";
}
